import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import {
    CandlestickTileConfigState,
    initialCandlestickTileConfigState,
} from 'widgets/candlestickTile/store/config/CandlestickTileConfigState';
import { buildSymbolDependentRequestHelpers } from 'widgets/streaming/buildSymbolDependentRequestHelpers';

export interface CandlestickTileStreamRequest {
    symbol: string;
    symbology: string;
    bucketSize: number;
}

export function toRequestUid(
    symbol: string,
    configState: CandlestickTileConfigState
): string {
    const config = configState ?? initialCandlestickTileConfigState;
    const { bucketSize } = config;
    return `priceChart-${symbol}|${bucketSize}`;
}

function requestToStreamKey(request: CandlestickTileStreamRequest): string {
    const { symbol, bucketSize } = request;
    return toRequestUid(symbol, { bucketSize, view: 'chart' });
}

function buildRequest(
    symbol: string,
    symbology: SymbologyValues,
    configState: CandlestickTileConfigState
): CandlestickTileStreamRequest {
    const config = configState ?? initialCandlestickTileConfigState;
    const { bucketSize } = config;
    return {
        symbol,
        symbology,
        bucketSize,
    };
}

const {
    createWidgetRequestUid,
    getWidgetStreamRequestInfo,
    getStreamRequestInfosForSymbols,
} = buildSymbolDependentRequestHelpers<
    CandlestickTileStreamRequest,
    CandlestickTileConfigState
>(
    toRequestUid,
    requestToStreamKey,
    buildRequest,
    initialCandlestickTileConfigState
);

export {
    createWidgetRequestUid as createCandlestickTileRequestUid,
    getWidgetStreamRequestInfo as getCandlestickRequestWithStreamKey,
    getStreamRequestInfosForSymbols as getCandlestickStreamRequestInfosForSymbols,
    toRequestUid as toCandlestickRequestUid,
};
